module.exports = __webpack_public_path__ + "media/images/front/services/transport-31f03ae979e78e866ec23e67d19af153.jpg";